import { __decorate } from "tslib";
import { CommonModule } from '@angular/common';
import { inject } from '@angular/core';
import { AppMessagesComponent } from '@common/messages/frontend-shared';
import { MinimalUiModule } from '@common/ui/frontend-shared';
import { DevConsoleProtocolLogger, ERROR_PAGE_DATA_DEFAULTS, FrontendFeaturePlugin, injectableProtocolFactory } from '@core/frontend-shared';
import { ROUTER_NAVIGATION_INTERCEPTOR, provideRootRoutes } from '@core/frontend-shared/router';
import { ClassName } from '@core/shared/class-name';
import { NgxsModule } from '@ngxs/store';
import { CoreBeginSessionByUrlComponent } from './begin-session-by-url';
import { CoreChunkErrorComponent } from './chunk-error';
import { CoreErrorMessageComponent } from './components/error-message.component';
import { CoreConnectionErrorComponent } from './connection-error';
import { CoreErrorPageGenericComponent } from './error-pages';
import { CoreLoginOverlayComponent } from './login-overlay';
import { NavigationService, ScrollToElementService } from './services';
import { VERSIONCHECK_PROTOCOL } from './token';
import { CoreVersioncheckComponent, VersioncheckState } from './versioncheck';
import * as i0 from "@angular/core";
import * as i1 from "@ngxs/store";
let CoreFrontendSharedFeature = /*#__PURE__*/(() => {
  let CoreFrontendSharedFeature = class CoreFrontendSharedFeature extends FrontendFeaturePlugin {
    constructor() {
      super(...arguments);
      this.x = inject(ScrollToElementService);
    }
    getFeatureContext() {
      return {"package":"@core/frontend-shared","featureId":"common-core"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineRootComponents([{
        component: CoreLoginOverlayComponent
      }, {
        component: CoreConnectionErrorComponent
      }, {
        component: CoreChunkErrorComponent
      }, {
        component: CoreVersioncheckComponent,
        excludeSSR: true
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵCoreFrontendSharedFeature_BaseFactory;
        return function CoreFrontendSharedFeature_Factory(__ngFactoryType__) {
          return (ɵCoreFrontendSharedFeature_BaseFactory || (ɵCoreFrontendSharedFeature_BaseFactory = i0.ɵɵgetInheritedFactory(CoreFrontendSharedFeature)))(__ngFactoryType__ || CoreFrontendSharedFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: CoreFrontendSharedFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'error',
          data: {
            pageTitle: 'Error',
            metaRobots: 'noindex, nofollow'
          },
          children: [{
            path: '403',
            component: CoreErrorPageGenericComponent,
            data: {
              pageTitle: '403 Error',
              metaRobots: 'noindex, nofollow',
              errorData: ERROR_PAGE_DATA_DEFAULTS.ERR_403
            }
          }, {
            path: 'router',
            component: CoreErrorPageGenericComponent,
            data: {
              pageTitle: 'Fehler',
              metaRobots: 'noindex, nofollow',
              errorData: ERROR_PAGE_DATA_DEFAULTS.ERR_ROUTER
            }
          }, {
            path: '',
            pathMatch: 'full',
            component: CoreErrorPageGenericComponent,
            data: {
              pageTitle: 'Fehler',
              metaRobots: 'noindex, nofollow'
            }
          }]
        }, {
          path: 'auth/begin-session-by-url',
          component: CoreBeginSessionByUrlComponent
        }]), {
          provide: ROUTER_NAVIGATION_INTERCEPTOR,
          useExisting: NavigationService,
          multi: true
        }, injectableProtocolFactory(VERSIONCHECK_PROTOCOL, 'VersionCheck', [DevConsoleProtocolLogger])],
        imports: [CommonModule, MinimalUiModule, AppMessagesComponent, CoreConnectionErrorComponent, CoreChunkErrorComponent, CoreLoginOverlayComponent, CoreErrorMessageComponent, CoreErrorPageGenericComponent, NgxsModule.forFeature([VersioncheckState])]
      });
    }
  };
  CoreFrontendSharedFeature = __decorate([ClassName("CoreFrontendSharedFeature")], CoreFrontendSharedFeature);
  return CoreFrontendSharedFeature;
})();
export { CoreFrontendSharedFeature };